module.exports = function() {
  return new Worker(__webpack_public_path__ + "1a37860eb48bab32e83c.worker.js");
};